<template>
    <div class="detail">
        <div class="detail_text" :class="{'show':openText}">
            <div class="content">
                <div class="title">{{info.title}}</div>
                <div class="text">
                    <p style="text-indent:2em;">{{info.content}}</p>
                </div>
                <div class="btsn">
                    <div class="btn" @click="show">隐藏</div>
                </div>
            </div>
        </div>

        <div class="openText" :class="{'show':!openText}" @click="show"></div>

        <div class="content_img" v-show="iscontent">
            <img :src="info.content_img" alt="">
        </div>

        <!-- <template v-if="!isiOS">
            <template v-if="!isfullScreen">
                <div class="fullscreen" @click="fullScreen"></div>  
            </template>
            <template v-else>
                <div class="fullscreen" :class="{'screen':isfullScreen}" @click="exitScreen"></div>
            </template>
        </template> -->

        <div id="container">
            <!-- <iframe :src="info.modelUrl" frameborder="0" allowfullscreen></iframe> -->
        </div>
        
        <!-- <div class="audio">
            <audio :src="info.musiz" preload="auto" autoplay="autoplay"></audio>
        </div> -->

        <div class="home" @click="back">
            <img src="static/images/home.png" alt="">
        </div>

        <template v-if="info.detail_title">
            <div class="openInner" @click="openInner">
                <img src="static/images/item.png" alt="">
            </div>
        </template>

        <template v-if="!isPC">
            <div class="iscontent" @click="iscontentchange">
                <img src="static/images/itemImg.png" alt="">
            </div>
        </template>
        

        <div class="openInnerBOXBc" v-if="musiz" @click="close"></div>
        <div class="openInnerBOX" v-if="musiz">
            <div class="close" @click="close">×</div>
            <div class="content">
                <div class="title">{{info.detail_title}}</div>
                <div class="img">
                    <img :src="info.detail_img" alt="">
                </div>
                <div class="content-txt" v-html="info.detail_content"></div>
            </div>
        </div>   
         

    </div>

</template>
<script>
    import { mapState } from "vuex"
    import * as THREE from "three";
    import {OBJLoader, MTLLoader} from 'three-obj-mtl-loader';
    import {CSS2DRenderer, CSS2DObject} from 'three-css2drender';

    // import Stats from './jsm/libs/stats.module.js';
    import { FBXLoader } from 'three-fbx-loader';

    import NProgress from 'nprogress';
    import 'nprogress/nprogress.css';
  
    const OrbitControls = require('three-orbit-controls')(THREE);
    export default {
        name: "vue-three",
        data() {
            return {
                id:'',
                scene: '',
                light: '',
                camera: '',
                controls: '',
                renderer: '',
                openText:false,
                isfullScreen:false,
                info:{},
                musiz:false,
                isiOS:false,
                iscontent:false,
                isPC:false,
                cube:'',
                v:0.002
            }
        },
        computed:{
            ...mapState(['list'])
        },
        created(){
            NProgress.start();
        },
        mounted() {
            const that = this
            this.id = this.$route.query.id
            var u = navigator.userAgent;
            this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if(this.id){
                this.list.forEach((item,index) => {
                    if(item.id == that.id){
                        this.info = item
                    }
                })
            }
            this.$nextTick(() => {
                this.$parent.isBox = true
                if(window.innerWidth <= 768){
                    this.openText = false
                    this.isPC = false

                }else{
                    this.openText = true
                    this.isPC = true
                    this.iscontent = true
                }
                if(this.isiOS){
                    var body = document.getElementById('body')
                    body.style.position = 'fixed';
                    body.style.height = '100%';
                }else{
                    if(window.innerWidth <= 768){
                        this.fullScreen()
                    }
                }

                window.audioPlay().play(true) 
                this.init();
                this.loadObj();
                this.animate();


            })
        },
        methods: {
            init() {
                this.scene = new THREE.Scene();
                this.scene.add(new THREE.AmbientLight(0xffffff));//环境光
                let plane = new THREE.Object3D();
                this.scene.add(plane)
                var directionalLight = new THREE.DirectionalLight( 0x222222, 0.1 );
                directionalLight.position.set(0,100,100)
                this.scene.add( directionalLight );

                var directionalLight1 = new THREE.DirectionalLight( 0x222222, 0.1 );
                directionalLight1.position.set(0,-100,-100)
                this.scene.add( directionalLight1 );

                if(this.info.code == "Z0301"){
                    var directionalLight2 = new THREE.DirectionalLight( 0xffffff, .03 );
                    directionalLight2.position.set(0,1000,10)
                    this.scene.add( directionalLight2 );
                }

                // //创建镜头光晕
                // var loader = new THREE.TextureLoader()
                // var textureFlare0 = loader.load("./lensflare/lensflare0.png");
                // var flareColor = new THREE.Color(0xffaacc);
                // var lensFlare = new THREE.LensFlare(textureFlare0, 170, 0.0, THREE.AdditiveBlending,
                // flareColor);
                // lensFlare.position.copy(directionalLight.position);
                // this.scene.add(lensFlare);

                //初始化相机
                this.camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 8000);
                this.camera.position.set(0, 0, 180);
                this.camera.lookAt(this.scene.position);
                //初始化控制器
                this.controls = new OrbitControls(this.camera);
                this.controls.target.set(0, 0, 0);
                this.controls.minDistance = 100
                this.controls.maxDistance  = 400
                this.controls.maxPolarAngle = Math.PI;
                this.controls.update();


                //渲染
                this.renderer =  new THREE.WebGLRenderer({antialias:true,alpha:true});//会在body里面生成一个canvas标签,
                this.renderer.setPixelRatio(window.devicePixelRatio);//为了兼容高清屏幕
                this.renderer.setSize(window.innerWidth, window.innerHeight);

                const container = document.getElementById('container');
                container.appendChild(this.renderer.domElement);
                window.addEventListener('resize', this.onWindowResize, false);//添加窗口监听事件（resize-onresize即窗口或框架被重新调整大小）
                document.getElementById('container').addEventListener('mousedown', this.clicks, false);//添加窗口监听事件（resize-onresize即窗口或框架被重新调整大小）
                document.getElementById('container').addEventListener('mouseup', this.clicksup, false);//添加窗口监听事件（resize-onresize即窗口或框架被重新调整大小）
                 document.getElementById('container').addEventListener('touchstart', this.clicks, false);
                document.getElementById('container').addEventListener('touchend', this.clicksup, false);
            },
            //窗口监听函数
            onWindowResize() {
                this.camera.aspect = window.innerWidth / window.innerHeight;
                this.camera.updateProjectionMatrix();
                this.renderer.setSize(window.innerWidth, window.innerHeight);
            },
            clicks(){
                this.v = 0
            },
            clicksup(){
                this.v = 0.002
            },
            animate() {

                this.requestAnima = requestAnimationFrame(this.animate);
                this.render();
            },
            render() {
                this.scene.rotation.y += this.v;
                this.renderer.render(this.scene, this.camera);
            },
            //外部模型加载函数
            loadObj() {
                const that = this
                //包含材质
               


                new MTLLoader().setPath('static/models/').load(that.info.mtl, materials => {
                    new OBJLoader().setMaterials(materials).setPath('static/models/').load(that.info.model, obj => {
                        obj.position.y = -0.5;
                        if(window.innerWidth <= 768){
                            obj.scale.set(.55, .55, .55)
                        }else{
                            obj.scale.set(1, 1, 1)
                        }
                        this.scene.add(obj);

                        if(!that.info.mtl1){
                            NProgress.done();
                        }
                    });
                });
                

                if(that.info.mtl1){
                    new MTLLoader().setPath('static/models/').load(that.info.mtl1, materials => {
                        new OBJLoader().setMaterials(materials).setPath('static/models/').load(that.info.model1, obj => {
                        
                            if(window.innerWidth <= 768){
                                obj.scale.set(.55, .55, .55)
                            }else{
                                obj.scale.set(1, 1, 1)
                            }
                            this.scene.add(obj);

                            if(!that.info.mtl2){
                                NProgress.done();
                            }
                        });
                    });
                }

                if(that.info.mtl2){
                    new MTLLoader().setPath('static/models/').load(that.info.mtl2, materials => {
                        new OBJLoader().setMaterials(materials).setPath('static/models/').load(that.info.model2, obj => {
                        
                            if(window.innerWidth <= 768){
                                obj.scale.set(.55, .55, .55)
                            }else{
                                obj.scale.set(1, 1, 1)
                            }
                            this.scene.add(obj);
                            NProgress.done();
                        });
                    });
                }
            },
            show(){
                this.openText = !this.openText
            },
            //全屏
            fullScreen(){
                var el = document.documentElement;
                var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;      
                    if(typeof rfs != "undefined" && rfs) {
                        rfs.call(el);
                        this.isfullScreen = true
                    };
                return;
            },
            exitScreen(){
                if (document.exitFullscreen) {  
                    document.exitFullscreen();  
                }  
                else if (document.mozCancelFullScreen) {  
                    document.mozCancelFullScreen();  
                }  
                else if (document.webkitCancelFullScreen) {  
                    document.webkitCancelFullScreen();  
                }  
                else if (document.msExitFullscreen) {  
                    document.msExitFullscreen();  
                } 
                if(typeof cfs != "undefined" && cfs) {
                    cfs.call(el);
                }
                this.isfullScreen = false
            },
            back(){
                this.$router.back()
            },
            openInner(){
                const that = this
                this.musiz = true
                window.audioPlay().play(false)
                    var setConfig = {
                    song : [
                        {
                            title : 'china',
                            src : that.info.detail_musiz
                        }
                    ],
                    error : function(meg){
                        console.log(meg);
                    }
                };
                var audioFn = audioPlay(setConfig);
                if(audioFn){
                    //开始加载音频,true为播放,false不播放
                    audioFn.loadFile(1);
                }
            },
            close(){
                const that = this
                this.musiz = false
                window.audioPlay().play(false)
                    var setConfig = {
                    song : [
                        {
                            title : 'china',
                            src : 'static/musiz/bc.mp3'
                        }
                    ],
                    error : function(meg){
                        console.log(meg);
                    }
                };
                var audioFn = audioPlay(setConfig);
                if(audioFn){
                    //开始加载音频,true为播放,false不播放
                    audioFn.loadFile(1);
                }
            },
            iscontentchange(){
                this.iscontent = !this.iscontent
            }
        }
    }
  </script>
  
  <style lang="scss" scoped>
    #container{
        width:100vw;
        height:100vh;

        iframe{
            display:block;
            width:100%;
            height:100%;
        }
    }
    .content_img{
        position: fixed;
        top:30px; left:30px;
        img{
            width:600px;
        }
    }
    .detail{
        width:100vw;
        height:100vh;
        background: url('../../public/static/images/detail_bc.jpg') center / cover;
        /* background-image: linear-gradient(to bottom right, #6c6368, #a8a2ae); */
    }
    .detail_text{
        position: fixed;
        top:0; left:-31.25%;
        width:31.25%;
        height:100%;
        background-color:rgba($color: #be8956, $alpha: .5);
        display:flex;
        justify-content:center;
        align-items:center;
        transition-duration:.5s;
        
        &.show{
            transition-delay:.2s;
            left:0;
        }
        .back{
            position: absolute;
            left:10%; top:30px;
            cursor: pointer;
            img{
                width:40px;
                display:block;
            }
        }
        .content{
            width:80%;

            .title{
                border-top:1px solid rgba($color: #be8956, $alpha: 1.0);
                border-bottom:1px solid rgba($color: #be8956, $alpha: 1.0);
                font-size:48px;
                color:#ffffff;
                line-height:60px;
                margin-bottom:30px;
                font-weight:400;
                padding:20px 0;
                font-weight:100;
            }
            .text{
                height:400px;
                overflow-y:auto;
                padding-right:10px;
                margin-bottom:20px;

                &::-webkit-scrollbar {
                    width:8px;
                    cursor: pointer;
                }

                /* 滚动槽 */
                &::-webkit-scrollbar-track {
                    border-radius:10px;
                    cursor: pointer;
                }

                /* 滚动条滑块 */
                &::-webkit-scrollbar-thumb {
                    border-radius:10px;
                    background:rgba($color: #be8956, $alpha: .8);
                    cursor: pointer;
                    &:hover{
                        background:rgba($color: #be8956, $alpha:1);
                    }
                }
                p{
                    font-size:18px;
                    color:#ffffff;
                    line-height:30px;
                }
            }
            .btsn{
                padding-top:50px;
                overflow: hidden;
                border-top:1px solid rgba($color: #be8956, $alpha: 1.0);
                .btn{
                    width:170px;
                    height:52px;
                    background:#be8956;
                    font-size:24px;
                    color:#392614;
                    text-align:center;
                    line-height:52px;
                    border-radius:8px;
                    float:right;
                    cursor: pointer;

                    &:hover{
                        background:#c38d59;
                        color:#000;
                    }
                }
            }
        }
    }
    .openText{
        position:fixed;
        top:0; bottom:0;
        left:-50px;
        margin:auto;
        width:50px;
        height:80px;
        font-size:24px;
        color:#fff;
        background:rgba($color: #be8956, $alpha: .2) url('../../public/static/images/right.png') center no-repeat;
        background-size:30px;
        cursor: pointer;
        transition-duration:.3s;
        &.show{
            transition-delay:.4s;
            left:0;
        }
        &:hover{
            background:rgba($color: #be8956, $alpha: .5) url('../../public/static/images/right.png') center no-repeat;
            background-size:30px;
        }
    }
    .fullscreen{
        position: fixed;
        right:30px; top:30px;
        width:40px;
        height:40px;
        background:url('../../public/static/images/big.png') center no-repeat;
        background-size:34px;
        cursor: pointer;
        transition-duration:.3s;
        &:hover{
            background:url('../../public/static/images/big.png') center no-repeat;
            background-size:34px;
        }

         &.screen{
            background:url('../../public/static/images/small.png') center no-repeat;
            background-size:34px;

            &:hover{
                background:url('../../public/static/images/small.png') center no-repeat;
                background-size:34px;
            }
        }
    }
    .audio{
        position:fixed;
        bottom:30px; right:30px;
        z-index:99;
        audio{
            opacity:0;
        }
    }
    .home{
        position:fixed;
        top:30px; right:30px;
        width:40px; height:40px;
        img{
            width:100%;
            display:block;
            cursor: pointer;
        }
    }
    .openInner{
        position:fixed;
        top:100px; right:30px;
        width:40px; height:40px;
        img{
            width:100%;
            display:block;
            cursor: pointer;
        }
    }
    .iscontent{
        position:fixed;
        top:170px; right:30px;
        width:40px; height:40px;
        img{
            width:100%;
            display:block;
            cursor: pointer;
        }
    }
    .openInnerBOXBc{
        position: fixed;
        width:100vw;
        height:100vh;
        z-index:998;
        top:0; left:0;
    }
    .openInnerBOX{
        position: fixed;
        width:90vw;
        height:90vh;
        z-index:999;
        background:#fff;
        top:5vh; left:5vw;
        padding:30px 20px;
        .content{
            height:100%;
            overflow-y:auto;
            padding:0 10px;
            &::-webkit-scrollbar {
                width:8px;
                cursor: pointer;
            }

            /* 滚动槽 */
            &::-webkit-scrollbar-track {
                border-radius:10px;
                cursor: pointer;
            }

            /* 滚动条滑块 */
            &::-webkit-scrollbar-thumb {
                border-radius:10px;
                background:rgba($color: #be8956, $alpha: .8);
                cursor: pointer;
                &:hover{
                    background:rgba($color: #be8956, $alpha:1);
                }
            }
        }

        .close{
            position: absolute;
            width:40px;
            height:40px;
            background:#000;
            border-radius:50%;
            right:-20px; top:-20px;
            color:#fff;
            line-height:40px;
            text-align:center;
            font-size:20px;
            cursor: pointer;
        }
        .title{
            font-size:30px;
            color:#000;
            text-align:center;
        }
        .img{
            margin-top:30px;
            img{
                max-width:80%;
                display:block;
                margin:auto;
            }
        }
        .content-txt{
            margin-top:30px;
            font-size:18px;
            line-height:30px;
        }
    }
    .audio-box1{
        position: absolute;
        background:#000;
        z-index:10000;
    }

    @media(max-width:768px){
        .detail_text{
            position: fixed;
            top:0; left:-100%;
            width:100%;
            height:100%;
            background-color:rgba($color: #000, $alpha: 1);
            display:flex;
            justify-content:center;
            align-items:center;
            transition-duration:.5s;
            z-index:999;

            .content{
                width:90%;
            }

            &.show{
                transition-delay:.2s;
                left:0;
            }

            .content{
                width:80%;

                .title{
                    border-top:1px solid rgba($color: #be8956, $alpha: 1.0);
                    border-bottom:1px solid rgba($color: #be8956, $alpha: 1.0);
                    font-size:24px;
                    color:#ffffff;
                    line-height:40px;
                    margin-bottom:30px;
                    font-weight:400;
                    padding:10px 0;
                    font-weight:100;
                }
                .text{
                    height:300px;
                    overflow-y:auto;
                    padding-right:10px;
                    margin-bottom:20px;

                    &::-webkit-scrollbar {
                        width:8px;
                        cursor: pointer;
                    }

                    /* 滚动槽 */
                    &::-webkit-scrollbar-track {
                        border-radius:10px;
                        cursor: pointer;
                    }

                    /* 滚动条滑块 */
                    &::-webkit-scrollbar-thumb {
                        border-radius:10px;
                        background:rgba($color: #be8956, $alpha: .8);
                        cursor: pointer;
                        &:hover{
                            background:rgba($color: #be8956, $alpha:1);
                        }
                    }
                    p{
                        font-size:14px;
                        color:#ffffff;
                        line-height:30px;
                    }
                }
                .btsn{
                    padding-top:30px;
                    overflow: hidden;
                    border-top:1px solid rgba($color: #be8956, $alpha: 1.0);
                    .btn{
                        width:140px;
                        height:40px;
                        background:#be8956;
                        font-size:16px;
                        color:#392614;
                        text-align:center;
                        line-height:40px;
                        border-radius:8px;
                        float:right;
                        cursor: pointer;

                        &:hover{
                            background:#c38d59;
                            color:#000;
                        }
                    }
                }
            }
        }

        
        .fullscreen,.home,.openInner,.iscontent{
            right:15px;
        }
        .openInnerBOX{
            padding:10px;
            height:calc(93vh - 50px);
            .title{
                font-size:24px;
            }

            .content{
                height:100%;
                overflow-y:auto;
                padding:0 10px;
                &::-webkit-scrollbar {
                    width:4px;
                    cursor: pointer;
                }

                /* 滚动槽 */
                &::-webkit-scrollbar-track {
                    border-radius:10px;
                    cursor: pointer;
                }

                /* 滚动条滑块 */
                &::-webkit-scrollbar-thumb {
                    border-radius:10px;
                    background:rgba($color: #be8956, $alpha: .8);
                    cursor: pointer;
                    &:hover{
                        background:rgba($color: #be8956, $alpha:1);
                    }
                }
            }

            .close{
                position: absolute;
                width:30px;
                height:30px;
                background:#000;
                border-radius:50%;
                right:-10px; top:-10px;
                color:#fff;
                line-height:30px;
                text-align:center;
                font-size:20px;
                cursor: pointer;
            }
        }

        >>> body{
            position: fixed;
            top:0; left:0;
        }

        .content_img{
            position: fixed;
            top:30px; left:0px;
            img{
                width:90%;
            }
        }
    }
</style>
<style>
    canvas{
        display:block;
    }
    .audiojs .play-pause{
        width:34px;
    }
    .audiojs .play{
        background: url('../../public/static/images/player-graphics.gif') -2px -1px no-repeat;
    }
    .audiojs .pause {
        background: url('../../public/static/images/player-graphics.gif') -2px -91px no-repeat;
    }
    .content-txt > div{
        text-indent: 2em;
        font-size: 16px;
        line-height: 1.4rem;
        margin: 0 0.5rem;
        color: #000;
    }
</style>
  